// extracted by mini-css-extract-plugin
module.exports = {"menu":"nav_menu__1RvP2","groupName":"nav_groupName__KFFzb","divider":"nav_divider__3Lf6i"};